let EtapaEnum = {
    PAGINA_INICIAL: {
        id: 0,
        nome: 'Página Inicial',
        codigo: 'PAGINA_INICIAL',
    },
    SOLICITACAO_DOCUMENTOS: {
        id: 1,
        nome: 'Solicitação de Documentos',
        codigo: 'SOLICITACAO_DOCUMENTOS',
    },
    GEO_PROPRIEDADE_POSSE: {
        id: 2,
        nome: 'Vetorização das áreas de Propriedade e Posse',
        codigo: 'GEO_PROPRIEDADE_POSSE',
    },
    GEO_RVN: {
        id: 3,
        nome: 'Vetorização do regime de proteção da RVN',
        codigo: 'GEO_RVN',
    },
    HABILITACAO_ATIVOS: {
        id: 4,
        nome: 'Habilitação de uso dos Ativos Ambientais',
        codigo: 'HABILITACAO_ATIVOS',
    },
};

export default EtapaEnum;
